import React, { useState } from 'react';
import clsx from 'clsx';
import { decorateName } from '@unmapped/core/utils';
import useFilteredResults from '@unmapped/core/hooks/useFilteredResults';
import UnmappedLayout from "../index.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
import OverlayHeader from "./OverlayHeader/index.js";
import useComponentOverride from "../../hooks/useComponentOverride.js";
import { useMap } from "../../hooks/useMap.js";
import { observer } from 'mobx-react-lite';
export var TwoColumnOverlayMapLayout = decorateName(observer(UnmappedLayout(_ref => {
  var {
    map,
    sidebar,
    sidebarLocation = 'left',
    results
  } = _ref;
  var [OverlayToggleButton] = useComponentOverride('layouts/TwoColumnOverlayMapLayout/OverlayToggleButton');
  var styles = useStyleOverride('layouts/TwoColumnOverlayMap', baseStyles);
  var {
    isLoaded
  } = useMap();
  var filteredResults = useFilteredResults();
  var [isOpen, setIsOpen] = useState(true);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.layout, sidebarLocation === 'right' && styles.sidebarRight)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sidebar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.sidebarInner
  }, sidebar)), /*#__PURE__*/React.createElement("div", {
    className: styles.map
  }, map), /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.overlay, isOpen ? styles.open : styles.closed, !isLoaded && styles.loading)
  }, isOpen ? /*#__PURE__*/React.createElement("div", {
    className: styles.overlayInner
  }, /*#__PURE__*/React.createElement(OverlayHeader, {
    sidebarLocation: sidebarLocation,
    resultCount: filteredResults.length,
    triggerCollapse: () => setIsOpen(false)
  }), results) : /*#__PURE__*/React.createElement(OverlayToggleButton, {
    direction: sidebarLocation === 'right' ? 'right' : 'left',
    onClick: () => setIsOpen(true)
  })));
})), 'TwoColumnOverlayMapLayout');
export default TwoColumnOverlayMapLayout;
//# sourceMappingURL=index.js.map